import {AxiosResponse} from "axios"
import {IEvent, IStandardResponse, TCompanyId} from "../types";
import {IEventDTO} from "../types/dtos/IEventDTO"
import {ICreateEventDTO} from "../types/dtos/ICreateEventDTO";
import {apiClient} from "./apiClient"

export const createEvent = async (companyId: TCompanyId, dto: ICreateEventDTO): Promise<IEvent> => {
    const url = `/companies/${companyId}/events`
    const res: AxiosResponse<IStandardResponse<IEventDTO>> = await apiClient.post(url, JSON.stringify(dto),
        {
            headers: {...window.BIOS.headers, "Content-Type": "application/json"},
        })
    const eventDTO = res.data.data

    return {
        id: eventDTO.id,
        eventType: eventDTO.event_type,
        deviceId: eventDTO.device_id,
        subjectId: eventDTO.subject_id,
        tags: eventDTO.tags,
        metadata: eventDTO.metadata,
        startTime: eventDTO.start_time,
        endTime: eventDTO.end_time,
        createdAt: eventDTO.created_at
    } as IEvent
};
